<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：商品管理
  -->
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="项目分类">
          <el-select size="small" v-model="searchForm.categoryId" placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务类型">
          <el-select size="small" v-model="searchForm.serviceId" placeholder="服务类型">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in serviceList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属商户">
          <el-select size="small" v-model="searchForm.shopSupplierId" placeholder="所属商户">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.shopSupplierId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否加钟">
          <el-select size="small" v-model="searchForm.isClock" placeholder="请选择是否加钟">
            <el-option label="全部" value=""></el-option>
            <el-option label="正常商品" value="0"></el-option>
            <el-option label="加钟商品" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否上架">
          <el-select size="small" v-model="searchForm.productStatus" placeholder="请选择是否上架">
            <el-option label="全部" value="0"></el-option>
            <el-option label="上架" value="10"></el-option>
            <el-option label="下架" value="20"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_id" label="项目ID"></el-table-column>
          <el-table-column prop="productName" label="项目图">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.image[0].filePath" alt="" /></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="项目名称"></el-table-column>
          <el-table-column prop="supplier.name" label="商户名称"></el-table-column>
          <el-table-column prop="service.name" label="服务类型"></el-table-column>
          <el-table-column prop="category.name" label="项目分类"></el-table-column>
          <el-table-column prop="productPrice" label="项目售价"></el-table-column>
          <el-table-column prop="isClock" label="是否加钟">
            <template slot-scope="scope">
              <span v-if="scope.row.isClock==0">正常商品</span>
              <span v-else-if="scope.row.isClock==1" style="color:red">加钟商品</span>
              <span v-else>全部</span>
            </template>
          </el-table-column>
          <el-table-column prop="sales_actual" label="销量"></el-table-column>
          <el-table-column prop="serviceTime" label="时长"></el-table-column>
          <el-table-column prop="productSort" label="排序"></el-table-column>
          <el-table-column prop="audit_remark" label="拒绝原因"></el-table-column>
          <el-table-column prop="productStatus.value" label="状态" align="center" width="100">
            <template slot-scope="scope">
              <el-switch class="switch" @change='projectstate(scope.row)' v-model="scope.row.productStatus.value" :active-value="10" :inactive-value="20" active-text="上架" inactive-text="下架">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="发布时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button :disabled="scope.row.audit_status==10" @click="agreeClick(scope.row)" type="primary" size="small">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--编辑-->
    <Agree v-if="open_agree" :open_agree="open_agree" :form="userModel" @closeDialog="closeDialogFunc($event, 'agree')"></Agree>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import PorductApi from "@/api/product.js";
import { deepClone } from "@/utils/base.js";
import Agree from "./part/agree.vue";
export default {
  components: {
    Agree
  },
  data() {
    return {
      open_agree: false,
      /*切换菜单*/
      activeName: "",
      /*切换选中值*/
      activeIndex: "0",
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: "",
        serviceId: "",
        isClock: "",
        categoryId: "",
        shopSupplierId: ""
        // productStatus: ""
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      serviceList: [],
      supplierList: [],
      /*商品统计*/
      product_count: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*打开编辑*/
    agreeClick(item) {
      this.userModel = deepClone(item);
      this.open_agree = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "agree") {
        this.open_agree = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    projectstate(row) {
      let self = this;
      PorductApi.projectstate({
        product_id: row.product_id,
        state: row.productStatus.value
      }).then(data => {
        self.$message({
          message: "修改成功",
          type: "success"
        });
        self.getData();
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      Params.type = self.activeName;
      self.loading = true;
      PorductApi.auditProductList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.categoryList = data.data.category;
          self.serviceList = data.data.serviceList;
          self.supplierList = data.data.supplierList;
          self.totalDataNumber = data.data.list.total;
          self.product_count = data.data.product_count;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    addClick(row) {
      this.$router.push("/product/product/add");
    },
    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: "/product/product/edit",
        query: {
          product_id: row.product_id,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("删除后将移动到回收站，确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          PorductApi.delProduct({
            product_id: row.product_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>
<style lang="scss">
.product-list {
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-right: 15px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 9px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }
}
</style>
<style lang="scss">
.product-list {
  /* switch按钮样式 */
  .switchs .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switchs .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switchs .el-switch__label--right span {
    margin-right: 15px;
  }
  /*关闭时文字位置设置*/
  .switchs .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switchs .el-switch__label--left span {
    margin-left: 9px;
  }
  /*显示文字*/
  .switchs .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switchs.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important;
    margin: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/product/serviceagree/index.vue